module.exports = __webpack_public_path__ + "img/kondispatch_partially.3714a848.svg";